import React from 'react';
import cls from './NotGivenRow.module.css';
import { useNotGivenRow } from './useNotGivenRow';
import classNames from 'classnames';

interface INotGivenRowProps {
    text?: string;
}

export const NotGivenRow = ({ text }: INotGivenRowProps) => {
    const { onClickInformation, can_show_financial_info, is_customer } = useNotGivenRow();
    return (
        <>
            {!text ? (
                <span
                    onClick={onClickInformation}
                    className={classNames(cls.isEmptyText, {
                        [cls.ClickedText]: can_show_financial_info && !is_customer,
                    })}
                >
                    {i18next.t('NotGivenRow.return.isEmptyText')}
                </span>
            ) : (
                <span
                    onClick={onClickInformation}
                    className={classNames(cls.isEmptyText, {
                        [cls.ClickedText]: can_show_financial_info && !is_customer,
                    })}
                >
                    {text}
                </span>
            )}
        </>
    );
};
